export default __webpack_public_path__ + "92f061bfa21e01797b44edb422f178c1.png";